export default __webpack_public_path__ + "img/9b5444080becc52875ca3b19813f36db.svg";